import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import Title from "../../uiKit/Title/Title";
import CommunityCard from "../../components/CommunityCard/communityCard";
import CommunitiesHeader from "./communitiesHeader";

import { getCommunities } from "../../redux/state/communitySlice";
import AnimatedLoading from "../../uiKit/Loading/animatedLoading";

const MyCommunities = () => {
  const dispatch = useDispatch();

  const [communitiesAdminRole, setCommunitiesAdminRole] = useState([]);
  const [communitiesMemberRole, setCommunitiesMemberRole] = useState([]);

  const memberCommunities = useSelector(
    (state) => state.community.memberCommunities,
    shallowEqual
  );
  const loading = useSelector(
    (state) => state.community.isLoading.common,
    shallowEqual
  );

  useEffect(() => {
    if (!!memberCommunities) return;
    dispatch(getCommunities());
  }, [memberCommunities, dispatch]);

  useEffect(() => {
    if (!memberCommunities) return;
    const communitiesAdminRole = memberCommunities.filter((e) => e.role === 1);
    setCommunitiesAdminRole(communitiesAdminRole);

    const communitiesMemberRole = memberCommunities.filter((e) => e.role === 0);
    setCommunitiesMemberRole(communitiesMemberRole);
  }, [memberCommunities]);

  return (
    <div>
      <CommunitiesHeader />
      <Title
        text={`Admin (${communitiesAdminRole.length})`}
        className="communityCardsWrapper"
        style={{ marginTop: "8px", marginBottom: "8px" }}
      />
      <div
        className={`communityCardsWrapper ${
          communitiesAdminRole.length > 4 ? "minHeight350" : ""
        }`}
      >
        {communitiesAdminRole.map((x) => (
          <div className="card">
            <CommunityCard community={x} key={x.id} isMember />
          </div>
        ))}
        <AnimatedLoading loading={loading} />
      </div>

      <Title
        text={`Member (${communitiesMemberRole.length})`}
        className="communityCardsWrapper"
        style={{ marginTop: "8px", marginBottom: "8px" }}
      />
      <div
        className={`communityCardsWrapper ${
          communitiesAdminRole.length > 4 ? "minHeight350" : ""
        }`}
      >
        {communitiesMemberRole.map((x) => (
          <div className="card">
            <CommunityCard community={x} key={x.id} isMember />
          </div>
        ))}
        <AnimatedLoading loading={loading} />
      </div>
    </div>
  );
};

export default MyCommunities;
